import axios from 'axios';
import { cachetime } from '../config';

export default function() {
  return {
    namespaced: true,
    state: {
      brochures: {},
    },
    mutations: {
      SET_BROCHURES(state, { data, locale }) {
        state.brochures = {
          ...state.brochures,
          [locale]: {
            data,
            __updatedAt: Date.now(),
          }
        }
      }
    },
    actions: {
      FETCH_BROCHURES({ state, commit }, { locale }) {
        if (state.brochures[locale] 
          && state.brochures[locale].data
          && Date.now() - state.brochures[locale].__updatedAt < cachetime
        ) {
          return ;
        }

        return axios.get('/api/brochures')
          .then((res) => {
            const data = res.data || [];
            if (data.length == 0) {
              throw {
                response: {
                  status: 404
                }
              }
            }
            commit('SET_BROCHURES', { data, locale});
          }).catch(err => {
            console.log(err);
            throw err
          });
      }
    },
    getters: {
      getBrochures: (state) => (locale) => {
        return state.brochures[locale] ? state.brochures[locale].data || [] : [];
      }
    }
  }
};